//#region components/keyboard_shortcut/keyboard_shortcut_constants.js
var e = [
	"{win}",
	"{arrow-right}",
	"{arrow-left}",
	"{arrow-up}",
	"{arrow-down}",
	"{cmd}",
	"{opt}"
];
//#endregion
export { e as SHORTCUTS_ALIASES_LIST };

//# sourceMappingURL=keyboard-shortcut-constants.js.map